import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { GeniePadElementsSettingItem } from '../../../api/pushGenie';
import { PrintConfig, Translate } from '../../../api/pushVisit';
import PrescriptionPDFPreview from '../../../pages/PrescriptionPDFPreview';

import { getMe, getTemplates, getTemplateV2, getVisitById } from '../../../store/idbHandler';
import { Prescription } from '../../../store/types/prescription';
import {
    RenderPdfPrescription,
    TemplateConfig,
    TemplateV2,
} from '../../../Templar/RenderPdfPrescription';
import { pushVisitWithSanitizePrescription } from './finishScreen/FinishedPanel';
import { SectionNameConfig } from '../../../store/db';
import RxTemplatePdfView, {
    RX_RENDER_PDF,
} from '../../../pages/editTemplate/common/RxTemplatePdfView';
import moment from 'moment';
import { DocProfileResponse } from '../../../api/fetchDoctorProfile';
import { setTemplateFieldIfEmpty } from '../../../pages/editTemplate/common/utils';
import { randomString } from '../../../store/utils';
import { NO_FOOTER, NO_HEADER } from '../../../pages/editTemplate/EditTemplate';

type Props = {
    elemId?: string;
    prescription: Prescription;
    printConfig: PrintConfig;
    setPrintUrl?: (url: string) => void;
    translate: Translate;
    onDummyIframeLoad?: () => void;
    medElements?: GeniePadElementsSettingItem[];
    padElementsConfig?: GeniePadElementsSettingItem[];
    sectionNameConfig?: SectionNameConfig;
    force?: boolean;
    onAlreadySavedError?: () => void;
};

export type ResData = {
    data: RenderPdfPrescription;
    config: TemplateV2;
};

const mapDoctorToDocProfileResponse = (doctor: any): DocProfileResponse | undefined => {
    if (!doctor) return undefined;

    if (doctor._id) return doctor;

    return {
        _id: doctor.id,
        profile: doctor.profile,
        created_at: doctor.created_at,
        updated_at: doctor.updated_at,
        loginmeta: doctor.loginmeta,
    };
};

type State = {
    pushStatus: 'loading' | 'success' | 'error';
    data?: ResData;
    activeClinic?: string | undefined;
    rxConfig?: TemplateConfig;
    rxLocalConfig?: TemplateConfig;
    doctorProfile?: DocProfileResponse;
};

class CreateLocalPdf extends PureComponent<Props, State> {
    state: State = {
        pushStatus: 'loading',
    };

    componentDidMount() {
        this.generatePreview();
    }

    generatePreview = (): void => {
        const { prescription, printConfig: printCofig, translate } = this.props;
        getVisitById(prescription.visitId).then(async (v) => {
            if (!v) {
                return;
            }

            const templates = getTemplates();

            const template_v2 = {
                render_pdf_config: await getTemplateV2(
                    prescription.doctor._id,
                    prescription.clinic._id,
                    'PRINT',
                ),
                render_pdf_body_config: {
                    medication_config:
                        this.props.medElements ||
                        this.state.data?.config?.render_pdf_body_config?.medication_config,
                    pad_elements_config:
                        this.props.padElementsConfig ||
                        this.state.data?.config?.render_pdf_body_config?.pad_elements_config,
                    section_name_config:
                        this.props.sectionNameConfig ||
                        this.state.data?.config?.render_pdf_body_config?.section_name_config,
                },
            } as TemplateV2;
            pushVisitWithSanitizePrescription(
                prescription,
                v.startedAt || new Date(),
                v.endedAt || new Date(),
                'print',
                printCofig,
                translate,
                templates?.print?.templateId,
                template_v2,
                undefined,
                false, //force
                undefined, //monetisation_type
                false, //ignoredraft
                '', //draftid
                true, //isfromcreatelocalpdf
            )
                .then(async (response) => {
                    this.setState({});
                    const doctorProfile = mapDoctorToDocProfileResponse(
                        response?.data?.data?.doctor,
                    );
                    // const currentActiveClinicId =
                    //     doctorProfile?.profile?.professional?.default_clinic ||
                    //     doctorProfile?.profile?.professional?.clinics?.[0]?._id;
                    const currentActiveClinicId = prescription.clinic._id;
                    const doctorTemplateData = doctorProfile?.profile?.professional?.templates_v2;
                    const templateData = doctorTemplateData?.find(
                        (data) => data.clinicId === currentActiveClinicId && data.type === 'PRINT',
                    );

                    this.setState({
                        activeClinic: prescription?.clinic._id,
                        pushStatus: response.status === 'success' ? 'success' : 'error',
                        data: response?.data,
                        doctorProfile: doctorProfile,

                        rxConfig: setTemplateFieldIfEmpty(
                            templateData
                                ? {
                                      ...templateData,
                                      header_img:
                                          templateData.header_img &&
                                          templateData.header_img != NO_HEADER
                                              ? `${templateData.header_img}?cacheoff=${randomString(
                                                    4,
                                                )}`
                                              : templateData.header_img,
                                      footer_img:
                                          templateData.footer_img &&
                                          templateData.footer_img != NO_FOOTER
                                              ? `${templateData.footer_img}?cacheoff=${randomString(
                                                    4,
                                                )}`
                                              : templateData.footer_img,
                                      attachment_image: templateData.attachment_image
                                          ? `${
                                                templateData.attachment_image
                                            }?cacheoff=${randomString(4)}`
                                          : templateData.attachment_image,
                                  }
                                : templateData,
                        ),
                    });
                })
                .catch((e) => {
                    console.error('preview pushData=>', e);
                    this.setState({
                        pushStatus: 'error',
                    });
                });
        });
    };

    saveRxConfigInState = () => {
        //NA
    };
    render() {
        const { pushStatus } = this.state;

        const { prescription } = this.props;

        if (pushStatus === 'loading') {
            return (
                <div
                    style={{ width: '100%', height: '100%' }}
                    className="flex flex-col items-center justify-center space-y-64"
                >
                    <div className="pulse">
                        <svg width="16px" height="12px">
                            <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                            <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                        </svg>
                    </div>
                </div>
            );
        }
        return this.state.data && this.state.doctorProfile ? (
            <>
                <div className="h-full" id={RX_RENDER_PDF}></div>
                <RxTemplatePdfView
                    data={{
                        ...this.state.data?.data,
                        date: moment().toISOString(),
                        actor: {
                            name: getMe()?.user.fn || '-',
                            id: getMe()?.user.oid || '-',
                        },
                    }}
                    rxConfig={{
                        render_pdf_config: this.state.rxConfig
                            ? {
                                  ...this.state.rxConfig,
                                  docid: this.props.prescription.doctor._id,
                                  clinicId: this.state.activeClinic || '',
                                  type: 'PRINT',
                              }
                            : undefined,
                        render_pdf_body_config: {
                            medication_config:
                                this.props.medElements ||
                                this.state.data?.config?.render_pdf_body_config?.medication_config,
                            pad_elements_config:
                                this.props.padElementsConfig ||
                                this.state.data?.config?.render_pdf_body_config
                                    ?.pad_elements_config,
                            section_name_config:
                                this.props.sectionNameConfig ||
                                this.state.data?.config?.render_pdf_body_config
                                    ?.section_name_config,
                        },
                    }}
                    // rxLocalConfig={rxLocalConfig}
                    activeClinic={this.state.activeClinic}
                    saveRxConfigInState={this.saveRxConfigInState}
                    docProfile={this.state.doctorProfile}
                    locallyCreatedPdf={true}
                />
            </>
        ) : (
            <PrescriptionPDFPreview id={prescription.id} />
        );
    }
}

export default connect()(CreateLocalPdf);
